import { TextArea, Modal, Button } from '@efast_public/fjd-component-library';
import { useEffect, useState } from 'react';
import { VermerkDto } from '../../../../../api/models/Vermerk/VermerkDto';
import { useProfile } from '../../../../../shared/hooks/AuthContext';

interface VermerkModalModalProps {
  readonly onClose: () => void;
  readonly onSave: (vermerk: VermerkDto) => Promise<void>;
  readonly onStateChanged: () => void;
  readonly disableInput: boolean;
  readonly vermerk?: VermerkDto;
  readonly isOpen: boolean;
}

export function VermerkModal({
  onClose,
  onSave,
  onStateChanged,
  disableInput,
  vermerk,
  isOpen
}: VermerkModalModalProps) {
  const [text, setText] = useState(vermerk?.description ?? '');

  const { profile } = useProfile();
  const bearbeiterId = profile?.id !== undefined ? profile?.id : '';
  const firstName = profile?.firstName !== undefined ? profile?.firstName : '';
  const lastName = profile?.lastName !== undefined ? profile?.lastName : '';

  return (
    <Modal
      appElement={document.querySelector('.fjd-base-layout') as HTMLElement}
      closeOnBackdropClick={false}
      open={isOpen}
      onClose={onClose}
    >
      <Modal.Header id="VermerkModal-header">Vermerk</Modal.Header>
      <Modal.Content>
        <TextArea
          id="vermerkText"
          minLength={1}
          maxLength={500}
          onChange={(event) => setText(event.target.value)}
          value={text}
          rows={6}
          placeholder="Hier können Sie individuelle Notizen vermerken."
          disabled={disableInput}
        />
      </Modal.Content>
      <Modal.Footer>
        <Button
          variant="secondary-outline"
          disabled={disableInput}
          onClick={onClose}
        >
          Abbrechen
        </Button>
        <Button
          variant="primary"
          disabled={disableInput || !text}
          onClick={() =>
            onSave({
              description: text,
              vermerkId: vermerk ? vermerk.vermerkId : undefined,
              version: vermerk?.version,
              bearbeiterDto: {
                id: bearbeiterId,
                firstName: firstName,
                lastName: lastName,
                fullName: `${firstName} ${lastName}`
              }
            }).finally(() => {
              onClose();
              onStateChanged();
            })
          }
        >
          Vermerk speichern
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default VermerkModal;
